import React from 'react';

const OverdraftFacilities = () => {
  return (
    <div style={{ padding: '50px', fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", lineHeight: '1.8' }}>
      <h1 style={{ fontSize: '36px', marginBottom: '20px', color: '#22225f' }}>Overdraft Facilities</h1>
      <p>
        Overdraft facilities provide businesses with a pre-approved credit limit to manage their working capital and cash
        flow efficiently. Use the funds only when needed and pay interest on the amount utilized.
      </p>
      <h2 style={{ fontSize: '28px', color: '#22225f', marginTop: '30px' }}>Features and Benefits</h2>
      <ul style={{ paddingLeft: '20px', listStyleType: 'disc' }}>
        <li>Access to funds anytime within the approved credit limit.</li>
        <li>Interest charged only on the amount utilized.</li>
        <li>Flexible renewal options for ongoing business needs.</li>
      </ul>
    </div>
  );
};

export default OverdraftFacilities;
